import API from "../../../../../services/api";
import { headers } from "../helpers/functionalities";

export const DESGUACES_OFFLINE_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/desguaces_offline?page=${page}${search || ''}`).then(res => res.data);
    },
    sendEmailById: async (offlineId, email) => {
        return API.post('desguaces_offline/' + offlineId + '/email', email).then(res => res.data);
    },
    import: async (excel) => {
        return API.post('desguaces_offline/import/excel', excel, headers).then(res => res.data);
    },
    createLeadFromSolicitud: async (solicitud) => {
        return API.post('desguaces_offline/new-presupuesto', solicitud).then(res => res.data);
    },
    downloadPDF: async (proforma) => {
        return API.post('desguaces_offline/download', proforma, {responseType: 'blob'}).then(res => res.data);
    },
    update: async (desguace) => {
        return API.put('desguaces_offline/' + desguace.id, desguace).then(res => res.data);
    }
}
